export default __webpack_public_path__ + "static/media/MP0017.68a9cfc5.jpg";